import TextInEdit from './TextInEdit';

export default {
  edit: {
    text: TextInEdit,
  },
};
